import Plyr from 'plyr'

import { getElementChild, getElements } from '../Utility/Dom'
import { IS_HIDDEN } from '../Utility/State'

class Video {
  private iframes: NodeListOf<HTMLIFrameElement>
  private previewButtons: NodeListOf<HTMLElement>
  private videos: NodeListOf<HTMLVideoElement>

  constructor() {
    this.iframes = getElements('video-iframe') as NodeListOf<HTMLIFrameElement>
    this.previewButtons = getElements('video-play-button')
    this.videos = getElements('video-local') as NodeListOf<HTMLVideoElement>
  }

  init(): void {
    this.addEvents()
  }

  private addEvents(): void {
    this.iframes.forEach((iframe): void => {
      iframe.addEventListener('consentAccepted', (): void => this.onConsentAccept(iframe))
      iframe.addEventListener('consentDeclined', (): void => this.onConsentDeclined(iframe))
    })

    this.previewButtons.forEach((button: HTMLElement): void => {
      const container: HTMLElement = button.parentElement
      const video = getElementChild(container, 'video-local') as HTMLVideoElement

      if (video) {
        button.removeAttribute('disabled')
      }

      button.addEventListener('click', (): void => {
        const container: HTMLElement = button.parentElement

        if (container) {
          const iframe = getElementChild(container, 'video-iframe') as HTMLIFrameElement
          const previewImage = getElementChild(container, 'video-preview') as HTMLElement | null

          if (iframe) {
            iframe.classList.remove(IS_HIDDEN)
            const src = iframe.dataset.src

            if (src) {
              const url = new URL(src)
              url.searchParams.set('autoplay', '1')
              iframe.src = url.toString()
            }
          }

          if (previewImage) {
            previewImage.classList.add(IS_HIDDEN)
          }

          button.classList.add(IS_HIDDEN)

          if (video) {
            video.play()
          }
        }
      })

      this.videos.forEach((localVideo: HTMLElement): void => new Plyr(localVideo))
    })
  }

  private onConsentAccept(iframe: HTMLIFrameElement): void {
    const src = iframe.dataset.src
    if (src) {
      iframe.src = src
    }

    const container = iframe.parentElement
    if (container) {
      const previewImage = getElementChild(container, 'video-preview')
      if (previewImage === null) {
        iframe.classList.remove(IS_HIDDEN)
      }

      const playButton = getElementChild(container, 'video-play-button')
      if (playButton !== null) {
        playButton.removeAttribute('disabled')
      }
    }
  }

  private onConsentDeclined(iframe: HTMLIFrameElement): void {
    iframe.removeAttribute('src')

    const container = iframe.parentElement
    if (container) {
      const playButton = getElementChild(container, 'video-play-button')
      if (playButton !== null) {
        playButton.setAttribute('disabled', 'disabled')
      }
    }
  }
}

const video = new Video()
video.init()
